import { render, staticRenderFns } from "./NutritionalScreeAssessResult.vue?vue&type=template&id=83433f06&scoped=true"
import script from "./NutritionalScreeAssessResult.vue?vue&type=script&lang=js"
export * from "./NutritionalScreeAssessResult.vue?vue&type=script&lang=js"
import style0 from "./NutritionalScreeAssessResult.vue?vue&type=style&index=0&id=83433f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83433f06",
  null
  
)

export default component.exports